<template>
  <div class="box1">
    <div class="title">AI产品经理</div>
    <div class="smallTitle">业务需求+AI  →  AI产品的缔造者</div>
    <img src="../../../assets/coursePage/pm/box1/main.png" alt="" />
    <div class="txt">
      AI 时代的产品经理，扎实的产品能力是基础<br/>AI 能力是助推器，实现职业突破
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
};
</script>

<style lang="less" scoped>
.box1 {
  position: relative;
  width: 100%;
  background: url("../../../assets/coursePage/pm/box1/1.png") no-repeat;
  background-size: cover;
  overflow: hidden;
  position: relative;
  height: 948px;
  box-sizing: border-box;
  padding-bottom: 80px;

  .title {
    font-size: 64px;
    font-family: SourceHanSansSC, SourceHanSansSC-Regular;
    font-weight: 600;
    color: #1e2259;
    line-height: 106px;
    -webkit-text-stroke: 1px #273f6e;
    text-stroke: 1px #273f6e;
    margin: 88px 0 0 74px;
  }
  .smallTitle {
    background: url("../../../assets/coursePage/pm/box1/box.png") no-repeat;
    font-size: 28px;
    font-family: PingFang SC;
    width: 538px;
    height: 88px;
    font-weight: 400;
    color: #273f6e;
    line-height: 36px;
    letter-spacing: 1px;
    margin: 20px 0 0 60px;
    padding: 16px 0 0 32px;
    box-sizing: border-box;
    background-size: contain;
  }
  img {
    margin: 26px 0 0 66px;
    width: 766px;
    height: 556px;
  }
  .txt {
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    z-index: 5;
    margin-top: -20px;
    width: 678px;
    height: 158px;
    left: 36px;
    bottom: 80px;
    background: rgba(255,255,255,0.2);
    box-shadow: 0px 14px 22px 0px #EDF8FD;
    border-radius: 20px;
    border: 4px solid #FFFFFF;
    backdrop-filter: blur(10px);
    font-size: 28px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #4e5969;
    line-height: 44px;
    box-sizing: border-box;
    text-align: center;
    p {
      font-size: 26px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #5f59ff;
      line-height: 44px;
      margin-top: 8px;
    }
  }
}
</style>
